import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    heading: 'subtitle-2'
  },
  enableFiltersCollape: false
} satisfies RecursivePartial<DialogConfig['filters']>
